import { combineReducers } from 'redux';
import {
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_ANNOUNCEMENTS_FAILURE,
  CHANGE_ANNOUNCEMENT_INFO,
  CHANGE_ANNOUNCEMENT_MESSAGE,
  SET_ANNOUNCEMENT_SELECTED_ERRORS,
  CLEAR_ANNOUNCEMENT_SELECTED_ERRORS,
  CLEAR_ANNOUNCEMENTS_DATA,
  CREATE_A_ANNOUNCEMENT_FAILURE,
  CREATE_A_ANNOUNCEMENT_REQUEST,
  CREATE_A_ANNOUNCEMENT_SUCCESS,
  FETCH_ANNOUNCEMENT_BY_ID_SUCCESS,
  FETCH_ANNOUNCEMENT_BY_ID_REQUEST,
  FETCH_ANNOUNCEMENT_BY_ID_FAILURE,
  EDIT_ANNOUNCEMENT_BY_ID_REQUEST,
  EDIT_ANNOUNCEMENT_BY_ID_SUCCESS,
  EDIT_ANNOUNCEMENT_BY_ID_FAILURE,
  DELETE_ANNOUNCEMENT_BY_ID_REQUEST,
  DELETE_ANNOUNCEMENT_BY_ID_SUCCESS,
  DELETE_ANNOUNCEMENT_BY_ID_FAILURE,
  CHANGE_ANNOUNCEMENT_FILTER_PARAMS_INFO,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ANNOUNCEMENTS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ANNOUNCEMENTS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};
const selected = (
  state = {
    current: {},
    announcementStat: null,
    errors: {},
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case CHANGE_ANNOUNCEMENT_MESSAGE:
      return {
        ...state,
        current: action.data,
      };
    case CHANGE_ANNOUNCEMENT_INFO: {
      const updateCurrunt = state.current;

      updateCurrunt[action.field] = action.value;

      return {
        ...state,
        current: updateCurrunt,
      };
    }
    case CHANGE_ANNOUNCEMENT_FILTER_PARAMS_INFO: {
      const updateCurrunt = state.current;

      if (!updateCurrunt.filterParams) {
        updateCurrunt.filterParams = {};
      }

      updateCurrunt.filterParams[action.field] = action.value;

      return {
        ...state,
        current: updateCurrunt,
      };
    }
    case SET_ANNOUNCEMENT_SELECTED_ERRORS:
      return {
        ...state,
        errors: action.data,
        loading: false,
      };
    case CLEAR_ANNOUNCEMENT_SELECTED_ERRORS:
      return {
        ...state,
        errors: {},
      };
    case CLEAR_ANNOUNCEMENTS_DATA:
      return {
        current: {},
        errors: {},
        announcementStat: null,
      };
    case CREATE_A_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };

    case CREATE_A_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        errors: action.data,
        loading: false,
      };
    }
    case CREATE_A_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        current: { dismissable: true, reappear: true, severity: 'default' },
      };
    case FETCH_ANNOUNCEMENT_BY_ID_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };
    case FETCH_ANNOUNCEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        current: action.data.data.data,
        loading: false,
      };
    case FETCH_ANNOUNCEMENT_BY_ID_FAILURE:
      return {
        ...state,
        errors: action.data,
        loading: false,
      };
    case EDIT_ANNOUNCEMENT_BY_ID_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };
    case EDIT_ANNOUNCEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case EDIT_ANNOUNCEMENT_BY_ID_FAILURE:
      return {
        ...state,
        errors: action.data,
        loading: false,
      };
    case DELETE_ANNOUNCEMENT_BY_ID_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };
    case DELETE_ANNOUNCEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        current: {},
        loading: false,
      };
    case DELETE_ANNOUNCEMENT_BY_ID_FAILURE:
      return {
        ...state,
        errors: action.data,
        loading: false,
      };
    default:
      return state;
  }
};

const announcements = combineReducers({
  list,
  selected,
});
export default announcements;
